"use client";

import { ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ExplanatoryText() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className={`bg-background py-16 px-4 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
      <div className="max-w-screen-xl mx-auto">
        <h2 className="text-foreground text-3xl font-semibold mb-4">
          Streamlined Dispatching for Owner-Operators
        </h2>
        <p className="text-foreground text-lg mb-6 max-w-3xl">
          At Oryx Fleet LLC, we handle the complexities of load coordination, rate negotiation, and billing so you can focus on what you do best—driving. Our flat-fee commission model ensures transparency and maximizes your earnings on every mile.
        </p>
        <Link to="#" className="inline-flex items-center gap-2 text-primary font-medium hover:text-primary-hover transition-colors duration-[var(--duration-medium)] hover:underline focus-ring">
          Here's how it works
          <ChevronRight className="w-5 h-5" />
        </Link>
      </div>
    </section>;
}